/** Send ESC/POS command to Android Printing application */
export const sendPrintCommandToAndroidPrintingApp = (escPosCommand: string) => {
    const base64Command = btoa(escPosCommand)

    const a = document.createElement('a')
    a.href = `orderwire://print?d=${encodeURIComponent(base64Command)}`
    a.click()
    a.remove()
}
